import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Alert, Button, Paper, Stack, Typography } from "@mui/material";
import { useMarketOps } from "../MarketOpsContext";

export default function OperationalResource({ title, resource }) {
  const ops = useMarketOps();
  return <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
    <Typography variant="h6" sx={{ mb: 2 }}>{title}</Typography>
    {ops.asset && <Typography sx={{ mb: 1 }}>{ops.asset.name} · {ops.asset.biddingZone || "Bidding zone missing"} · {ops.asset.timeZone || "Time zone missing"}</Typography>}
    {(ops.asset?.issues || []).map((issue) => <Alert severity="warning" key={issue} sx={{ mb: 1 }}>{issue}</Alert>)}
    <Alert severity="info">{ops.resources[resource]?.reason || "Operational data is not available for this asset."}</Alert>
    <Stack direction="row" spacing={1} sx={{ mt: 2 }} flexWrap="wrap">
      <Button component={RouterLink} to="/ops/assets">Portfolio &amp; Onboarding</Button>
      {(resource === "passes" || resource === "settings") && <Button component={RouterLink} to="/optimize">Daily Optimization</Button>}
      {resource === "passes" && <Button component={RouterLink} to="/dashboard?view=optimization">Historic Runs</Button>}
      {resource === "inputs" && <Button component={RouterLink} to="/dashboard?view=market&marketTab=prices">Market Data</Button>}
    </Stack>
  </Paper>;
}
